import { Dialog } from '@headlessui/react';

// Hooks
import useUrlUserHomepage from '@/utils/hooks/user/useUrlUserHomepage';

// Components
import Iconosquare from '@/components/icons/Iconosquare';
import MenuNotifications from '@/components/composite/Menu/MenuNotifications';
import LinkBase from '@/components/base/LinkBase';

const MenuSidebarHeader = () => {
    const { userHomepage } = useUrlUserHomepage();

    return (
        <div className="flex items-center justify-between">
            <Dialog.Title>
                <LinkBase className="flex items-center space-x-2 text-xs" href={userHomepage}>
                    <Iconosquare size={16} className="text-icoBlue" />
                    <p className="font-GSemiBold">iconosquare</p>
                </LinkBase>
            </Dialog.Title>
            <MenuNotifications size="base" />
        </div>
    );
};

export default MenuSidebarHeader;
